import { render, staticRenderFns } from "./BindsAppInternalDrawer.vue?vue&type=template&id=2372ab8a&"
import script from "./BindsAppInternalDrawer.vue?vue&type=script&lang=js&"
export * from "./BindsAppInternalDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BindsAppInternalDrawer.vue?vue&type=style&index=0&id=2372ab8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports